import { setAlertModalState } from '../../common/data/actions'

export const handleRealBooksLedgerNameSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, gstinNo, ledgerCode , panNo} = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('rlb_gstin', gstinNo)
        setFieldValue('rlb_id', ledgerCode)
        setFieldValue('rlb_pan', panNo)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('rlb_gstin', "")
        setFieldValue('rlb_id', "")
        setFieldValue('rlb_pan', "")
    }
}
export const handleRealBooksLedgerNameOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('rlb_gstin', "")
        setFieldValue('rlb_id', "")
        setFieldValue('rlb_pan', "")
    }
}

export const handleDebitMsilLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, gstinNo, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('dr_msil_code', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('dr_msil_code', "")
    }
}
export const handleDebitMsilLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('dr_msil_code', "")
    }
}

export const handleCreditMsilLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, gstinNo, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('cr_msil_code', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('cr_msil_code', "")
    }
}
export const handleCreditMsilLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('cr_msil_code', "")
    }
}

export const handleDealerDiscountSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, gstinNo, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('dler_disc_code', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('dler_disc_code', "")
    }
}
export const handleDealerDiscountOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('dler_disc_code', "")
    }
}

export const handleControllingLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (obj) {
        const { ledgerName, gstinNo, ledgerCode } = obj
        setFieldValue(fieldName, ledgerName)
        setFieldValue('control_ldgr_code', ledgerCode)
    } else {
        setFieldValue(fieldName, '')
        setFieldValue('control_ldgr_code', "")
    }
}
export const handleControllingLedgerOnBlur = (e, values, setFieldValue, fieldName, obj, dispatch) => {
    if (!e.target.value) {
        setFieldValue('control_ldgr_code', "")
    }
}

// PAN validation: 5 uppercase letters + 4 digits + 1 uppercase letter
const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/

// GSTIN validation: 2 digits + 5 letters + 4 digits + 1 letter + 1 alphanumeric + Z + 1 alphanumeric
const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/

export const validatePAN = (dispatch) => (e, values, index, setFieldValue, fieldValue, fieldName) => {
    if (fieldValue && fieldValue.trim() !== '') {
        const upperValue = fieldValue.toUpperCase().trim()
        setFieldValue(fieldName, upperValue)
        if (!PAN_REGEX.test(upperValue)) {
            dispatch(setAlertModalState({
                isOpen: true,
                type: 'error',
                title: 'Validation Error',
                msg: 'Invalid PAN format (e.g., ABCDE1234F)',
                size: 'tiny'
            }))
            setFieldValue(fieldName, '')
        }
    }
}

export const validateGSTIN = (dispatch) => (e, values, index, setFieldValue, fieldValue, fieldName) => {
    if (fieldValue && fieldValue.trim() !== '') {
        const upperValue = fieldValue.toUpperCase().trim()
        setFieldValue(fieldName, upperValue)
        if (!GSTIN_REGEX.test(upperValue)) {
            dispatch(setAlertModalState({
                isOpen: true,
                type: 'error',
                title: 'Validation Error',
                msg: 'Invalid GSTIN format (e.g., 27ABCDE1234F1Z5)',
                size: 'tiny'
            }))
            setFieldValue(fieldName, '')
        }
    }
}
